import { Component, OnInit } from '@angular/core';
import { InfoMessageService } from '../services/infomessage/infomessage.service';
import { InfoMessageItem } from '../models/infomessage';
import { ReturnObject } from '../models/returnObject';
import { InternalMsgService } from '../services/internal.msg.service';
import { StatusMessagesService } from '../services/statusmessage.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


    levels = [ 'message-critical', 'message-warning', 'message-info'];
    messages: InfoMessageItem[] = [];
    spinnerMessage: string = '';

    constructor(private infoMessage: InfoMessageService,
        private msgService: InternalMsgService,
        private statusMessagesService: StatusMessagesService) {
        this.getMessages();
    }

    ngOnInit(): void {
        this.msgService.onSelectedMenuSet( 0 );
    }

    getMessages(): void {
        this.msgService.ontoggleSpinnerSet(true);
        this.infoMessage.getmessages()
            .subscribe( {
                next: (data: ReturnObject<InfoMessageItem[]>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.messages = data.value;
                },
                error: (err) => {
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }


    getVariant(message: InfoMessageItem): string {
        if (message.importance == 1) return 'error';
        if (message.importance == 2) return 'warning';
        if (message.importance == 3) return 'success';
        return '';
    }

}
